import { useTranslation } from "react-i18next"
import ReactMarkdown from "react-markdown"

import styles from "@/features/chat/styles/answer.module.css"
import { cn } from "@/lib/utils"

/**
 * Shared Microsoft 365 consent copy. Rendered by the standalone
 * `M365InfoModal` (chat home, composer toggle, Studio, Tender) and inline by
 * the onboarding wizard's consent step, so both hosts always show the same
 * scope description and approval notice.
 */

/** Title text; the host supplies the heading element. */
export function M365ConsentHeading({ title }: { title?: string }) {
  const { t } = useTranslation()
  return <>{title ?? t("m365_tool.info.title")}</>
}

/** Scope description (markdown) followed by the approval notice. */
export function M365ConsentBody() {
  const { t } = useTranslation()
  return (
    <>
      <div className={cn(styles.answerText, "prose dark:prose-invert")}>
        <ReactMarkdown>{t("m365_tool.info.description")}</ReactMarkdown>
      </div>
      <p className="text-muted-foreground mt-4 text-sm">{t("m365_tool.info.approval_notice")}</p>
    </>
  )
}
